import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import Select from "react-select";
import { FaSpinner } from "react-icons/fa";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as Yup from "yup";
import {
  GetServiceCaller,
  PostServiceCaller,
} from "../../../../services/serviceCaller";
import { API_URL } from "../../../../constants";

const ModelMasterEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Edit Models"));
  }, []);

  const initialFormData = {
    ID: "",
    BrandID: null,
    Model: "",
    Remark: "",
    IsInActive: "",
    CategoryID: null,
    // RevisionNumber:''
  };

  const [formData, setFormData] = useState(initialFormData);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState([]);
  const [CategoryListOption, setCategoryListOption] = useState([]);
  const [brandListOption, setBrandListOption] = useState([]);
  const [pageLoading, setPageLoading] = useState(true);
  const [selectedRating, setSelectedRating] = useState(null);
  useEffect(() => {
    fetchGetModelMasters();

    if (id) {
      fetchModelMastersShow(id);
    }
  }, []);

  const fetchGetModelMasters = async () => {
    const response = await GetServiceCaller(`${API_URL}model-masters`);
    if (response.status === 200) {
      const fetchData = response?.data;
      const AssetCategory = fetchData?.assetCategoryList?.map((ele, index) => ({
        value: ele?.value,
        label: ele?.text,
      }));
      setCategoryListOption(AssetCategory);
      setLoading(false);
      setPageLoading(false);
    } else {
      console.error(
        "Failed to fetch model masters. Server responded with status:",
        response.status
      );
    }
  };
  const fetchModelMastersShow = async (id) => {
    const response = await GetServiceCaller(`${API_URL}model-masters/${id}`);
    if (response.status === 200) {
      const fetchData = response?.data?.data;
      const formDataEdit = {
        ID: fetchData?.ID,
        BrandID: fetchData?.BrandID,
        Model: fetchData?.Model,
        Remark: fetchData?.Remark,
        IsInActive: Number(fetchData?.IsInActive),
        CategoryID: fetchData?.CategoryID,
        // RevisionNumber: fetchData?.RevisionNumber
      };
      setFormData(formDataEdit);
      setLoading(false);
    } else {
      console.error(
        "Failed to fetch model masters. Server responded with status:",
        response.status
      );
    }
  };
  useEffect(() => {
    if (formData?.CategoryID) {
      fetchGetBrandsDetails(formData.CategoryID);
      setBrandListOption([]);
    }
  }, [formData?.CategoryID]);
  const fetchGetBrandsDetails = async (id) => {
    try {
      const queryParams = new URLSearchParams({
        CategoryID: id,
      });
      const response = await GetServiceCaller(
        `${API_URL}get-brands?${queryParams.toString()}`
      );
      if (response.status === 200) {
        const fetchData = response?.data?.data;
        const brandlist = fetchData?.map((ele, index) => ({
          value: ele?.ID,
          label: ele?.Brand,
        }));
        setBrandListOption(brandlist);

        setLoading(false);
      } else {
        console.error(
          "Failed to fetch model masters. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("An error occurred while fetching brand details:", error);
    }
  };
  const schema = Yup.object().shape({
    BrandID: Yup.number()
      .typeError("Brand is required")
      .required("Brand is required")
      .nullable(),
    Model: Yup.string().required("Model is required"),
    CategoryID: Yup.number()
      .typeError("Category is required")
      .required("Category is required")
      .nullable(),
    // Remark: Yup.string(),
  });
  const validateField = async (fieldName, updatedData) => {
    try {
      // Validate the specific field
      await schema.validateAt(fieldName, updatedData);

      // Clear the error for the specific field if validation is successful
      setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: "" }));
    } catch (err) {
      if (err.path === fieldName) {
        // Update the error only for the specific field
        setErrors((prevErrors) => ({
          ...prevErrors,
          [fieldName]: err.message,
        }));

        // Show error using toast for specific fields if needed
        if (fieldName.startsWith("lines")) {
          toast.error(err.message, { position: "top-right" });
        }
      } else {
        console.error("Validation error structure is not as expected:", err);
      }
    }
  };

  const handleChange = async (e) => {
    const { name, value } = e.target;

    // Update form data only for fields in the schema
    if (schema.fields[name]) {
      setFormData((prevData) => {
        const updatedData = { ...prevData, [name]: value };
        validateField(name, updatedData);
        return updatedData;
      });
    }
  };
  const handleRemarkChange = (e) => {
    const { name, value } = e.target;
  
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const handleSelect = async (selectedOption, name) => {
    setFormData((prevData) => {
      const updatedData = { ...prevData, [name]: selectedOption.value };
      // Trigger validation for the specific field after updating
      validateField(name, updatedData);
      return updatedData;
    });
  };
  const handleRatingChange = (ratingValue) => {
    setSelectedRating(ratingValue);
    setFormData({
      ...formData,
      IsInActive: ratingValue == "Yes" ? 1 : 0,
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // Validate formData using schema
      await schema.validate(formData, { abortEarly: false });
      setErrors({}); // Clear previous errors

      // Call the API
      const response = await PostServiceCaller(
        `${API_URL}model-masters/${id}`,
        formData,
        "put"
      );

      if (response.status === 200) {
        toast.success("Data submitted successfully");
        // Redirect after a successful submission
        setTimeout(() => {
          navigate("/model-master");
        }, 2000);
      } else {
        console.error(
          "Failed to submit data. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      if (error.name === "ValidationError") {
        const validationErrors = {};
        error.inner.forEach((err) => {
          validationErrors[err.path] = err.message;
        });
        setErrors(validationErrors);
      } else {
        console.error("Unexpected Error:", error);
      }
    } finally {
      setLoading(false);
    }
  };

  if (pageLoading) {
    return (
      <>
        <p class="position-absolute top-50 start-50 translate-middle text-center">
          <FaSpinner class="spinner" />
        </p>
      </>
    );
  } else {
    return (
      <>
     <div className="Container">
              <form
                  id="formOne"
                className="rounded bg-white mt-2"
                onSubmit={handleSubmit}
              >
              <div className="p-2">
                <div class="card-body  mx-2">
                  <div className="row">
                    <div className="col-md-4">
                      <label class="form-label">
                        Category<span className="text-danger">*</span>
                      </label>
                      <Select
                        name="CategoryID"
                        onChange={(selectedOption, action) => {
                          handleSelect(selectedOption, action.name);
                          setFormData((prevData) => ({
                            ...prevData,
                            BrandID: null,
                          }));
                        }}
                        value={CategoryListOption?.find(
                          (o) => o.value === formData?.CategoryID
                        )}
                        className={` ${errors.CategoryID ? "is-invalid" : ""}`}
                        options={[
                          { value: null, label: "Select" },
                          ...CategoryListOption,
                        ]}
                      />
                      {errors.CategoryID && (
                        <div className="invalid-feedback">
                          {errors.CategoryID}
                        </div>
                      )}
                    </div>
                    <div className="col-md-4">
                      <label class="form-label">
                        Make<span className="text-danger">*</span>
                      </label>
                      <Select
                        name="BrandID"
                        onChange={(selectedOption, action) =>
                          handleSelect(selectedOption, action.name)
                        }
                        value={
                          brandListOption?.find(
                            (o) => o.value === formData?.BrandID
                          ) || null
                        }
                        className={`${errors.BrandID ? "is-invalid" : ""}`}
                        options={[
                          { value: null, label: "Select" },
                          ...brandListOption,
                        ]}
                      />
                      {errors.BrandID && (
                        <div className="invalid-feedback">{errors.BrandID}</div>
                      )}
                    </div>
                    <div className="col-md-4">
                      <label class="form-label">
                        Model<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control ${
                          errors.Model ? "is-invalid" : ""
                        }`}
                        onChange={(e) => handleChange(e)}
                        name="Model"
                        value={formData?.Model}
                      />
                      {errors.Model && (
                        <div className="invalid-feedback">{errors.Model}</div>
                      )}
                    </div>
                  </div>
                  <div className="row mt-2">
                    <div className="col-md-4">
                      <label class="form-label">Remark</label>
                      <textarea
                        name="Remark"
                        value={formData?.Remark}
                        onChange={(e) => handleRemarkChange(e)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-6 mt-4">
                      <div className="d-flex gap-2 justify-content-start">
                        <label htmlFor="IsInActive" className="form-label">
                          Active
                        </label>
                        <input
                          className="form-check-input ms-2"
                          type="checkbox"
                          name="IsInActive"
                          id="flexSwitchCheckChecked"
                          checked={formData.IsInActive === 1}
                          onChange={(e) =>
                            setFormData((prevFormData) => ({
                              ...prevFormData,
                              IsInActive: e.target.checked ? 1 : 0,
                            }))
                          }
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="d-flex justify-content-end">
                      <div className="d-flex">
                        <div>
                          <button
                            type="button"
                            className="cancel-btn me-2"
                            onClick={() => navigate(`/model-master`)}
                          >
                            Cancel
                          </button>
                        </div>
                        <div>
                          <button
                            disabled={loading ? true : false}
                            type="submit"
                            className="custom-btn"
                          >
                            {loading ? (
                              <FaSpinner class="sm-spinner" />
                            ) : (
                              "Submit"
                            )}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
      </>
    );
  }
};

export default ModelMasterEdit;
